import React from "react";
import {connect} from "react-redux";
import languages from "../collections/languages"

class heading extends React.Component {
    constructor(props) {
        super ( props )
        this.state = {
            lang : this.props.lang
        }
    }


    render() {
        return (
            <h3 className={"heading"}>{!languages[this.props.lang]?" ":languages[this.props.lang][this.props.text]}</h3>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

export const Heading = connect ( mapStateToProps ) ( heading );